import { InformationIcon } from '@/lib/constants/icons.js';
import IconV2 from '@/components/v2/IconV2.jsx';

const Info = ({ title, className, style }) => {
  return <IconV2 icon={InformationIcon} title={title} variant={'light'} className={className} style={style} />;
};

export default Info;
